var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coming_lottery"},[_c('div',{staticClass:"title"},[_c('img',{staticClass:"icon",attrs:{"src":require(`@/img/icon/award-symbol.png`)}}),_vm._v(" 即将开奖 ")]),_c('div',{staticClass:"body"},_vm._l((_vm.comingLottery),function(item,index){return _c('LotteryCardType1',{key:'coming'+index,attrs:{"lotteryCode":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }